import React from "react";
// import { Outlet } from "react-router-dom";
import InternalSidebar from "../pages/InternalManagement/InternalSidebar";
import { useSelectAccess } from "../store/stateFunctions";
import { Navigate, Outlet } from "react-router-dom";

const InternalContainer = () => {
  document.title = "Internal User";
  const internaluser = useSelectAccess("Internal User");
  return (
    <>
      {console.log(internaluser)}
      <div className="row ">
        <InternalSidebar role="Internal User" />
        <div className="container">
          {internaluser ? <Outlet /> : <Navigate to="/internaluser" />}
        </div>
      </div>
      {/* <div className="row ">
          <div className="col-md-3">
            <Sidebar role="Super Admin" />
          </div>
          <div className="col-md-9">
            <div className="container">
              {superadmin ? <Outlet /> : <Navigate to="/superadmin" />}
            </div>
          </div>
        </div> */}
    </>
  );
};

export default InternalContainer;
